export const buildDataUrl = (path, query) => {
  const dummyData = false; // NODE_ENV === 'development';

  let urlPath = '';
  if (path.match(/^http/)) {
    const matches = path.match(/(http[s]?:\/\/)?([^/\s]+\/)(.*)/);
    urlPath = matches[3] || path;
  } else {
    urlPath = path;
  }

  const urlPathWithoutExt = urlPath.replace(/\.[^/.]+$/, '');

  const extension = dummyData ? 'json.js' : 'json';
  const queryString = query || '';

  const queryStringParams = path.split('?');
  const regex = /^\/(de|en)\//;
  const splitted = queryStringParams[0].split(regex);
  const apiHost =
    typeof window !== 'undefined'
      ? process.env.NEXT_PUBLIC_JSON_API_HOST
      : process.env.INTERNAL_JSON_API_HOST;

  let dataUrl = '';

  if (queryStringParams.length > 1) {
    dataUrl = `${apiHost}/${splitted[0]}.${extension}${`?${queryStringParams[1]}`}`;
  } else {
    dataUrl = `${apiHost}/${urlPathWithoutExt}.${extension}${dummyData ? '' : queryString}`;
  }

  return dataUrl;
};

export const buildUniversalDataUrl = path => {
  const apiHost =
    typeof window !== 'undefined' ? process.env.NEXT_PUBLIC_JSON_API_HOST : process.env.INTERNAL_JSON_API_HOST;
  const dummyData = false; // NODE_ENV === 'development';
  console.log(apiHost);
  const extension = dummyData ? 'json.js' : 'json';
  const queryString = path.split('?');
  const regex = /^\/(de|en)\//;
  const splitted = queryString[0].split(regex);

  let dataUrl = '';

  if (splitted.length === 1) {
    dataUrl = `${apiHost}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/${splitted[0]}.${extension}${
      queryString.length > 1 ? `?${queryString[1]}` : ''
    }`;
  } else {
    dataUrl = `${apiHost}/${splitted[1]}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/${splitted[2]}.${extension}${
      queryString.length > 1 ? `?${queryString[1]}` : ''
    }`;
  }
  return dataUrl;
};

/**
 * Formats filter query string
 * @param {array} filters - Array of selected filters
 * @param {string} key - key of query
 * @returns {string} Filter query
 */
export const formatFilterQuery = (filters, key = 'filters') => {
  const formattedFilters = typeof filters === 'string' ? [filters] : filters;

  let formattedQuery = '';

  if (formattedFilters && formattedFilters.length > 0) {
    formattedQuery = `${key}[]=${formattedFilters.join(`&${key}[]=`)}`;
  }

  return formattedQuery;
};

/**
 * Formats page and filters to a filter query string
 * @param {array} filters - Array of selected filters
 * @param {number} page - Page number of current page
 * @param {string} key - key of query
 * @returns {string} Filter query
 */
export const buildFilterQuery = (filters, page = null, key = 'filters') => {
  let query = '';

  const formattedFilterQuery = formatFilterQuery(filters, key);

  if (formattedFilterQuery) {
    query = `?${formattedFilterQuery}${page ? `&page=${page}` : ''}`;
  } else if (page) {
    query = `?page=${page}`;
  }

  return query;
};

export const buildFilterUrl = (path, filters) => {
  let updatedPath = path;

  const dummyPath = 'de/_filter/filter';

  // Check if path is index page
  if (path === '/de/' || path === '/en/' || path === '/') {
    updatedPath = `${path}index`;
  } else if (path === '/de' || path === '/en') {
    updatedPath = `${path}/index`;
  }

  // Local dev filter json
  const url = process.env.NODE_ENV === 'development' ? dummyPath : updatedPath;

  const dataUrl = buildUniversalDataUrl(url);
  const query = buildFilterQuery(filters);

  const dataUrlWithQuery = `${dataUrl}${process.env.NODE_ENV === 'development' ? '' : query}`;

  if (process.env.NODE_ENV === 'development') {
    console.log(`Getting real data from: ${updatedPath}.json${query}`);
    console.log(`Getting dummy data from: ${dataUrl}`);
  }

  return dataUrlWithQuery;
};

export const fetchCsrfToken = (onSuccess, onError) => {
  const path = `${process.env.NEXT_PUBLIC_JSON_API_HOST}/actions/users/session-info`;

  fetch(path, {
    credentials: 'include',
    headers: {
      Accept: 'application/json'
    }
  })
    .then(res => res.json())
    .then(json => {
      onSuccess(json.csrfTokenValue);
    })
    .catch(err => onError(err));
};
